module.exports = __webpack_public_path__ + "static/media/18_l_stena_0_0.1bfc8b05.png";